<script>
    import { onMount } from 'svelte'
    import { EditPass, ResetEditPass, ValidationValue, ContetnsEditCheck } from '../../../script/handle/detail'

    export let Num, ShowEditModal

	let dialog, data
    EditPass.subscribe(v => { data = v})

    $: if (dialog && ShowEditModal) {
        dialog.showModal(); 
    }

	onMount(async () => {
        data.pass = ''
        data.check = ''
    })

    // Modal 종료
	function closeModal() {
		ShowEditModal = false
        ResetEditPass()
		dialog.close()
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
	bind:this={dialog}
	on:close={() => closeModal()}
	on:click|self={() => closeModal()}
    class='editModal'
>
	<!--<div class='monsterModal' on:click|stopPropagation>-->
        <div class="title">비밀번호 확인</div>

        <div class="form">
            <div class='grid'>
                <label>비밀번호</label>
                <input
                    type="password"
                    placeholder='20자 이하 입력!'
                    bind:value={data.pass}
                    on:input={() => ValidationValue()}
                />
            </div>

            {#if data.check != true && data.check != ''}
                <div class='issue'>
                    {data.check}
                </div>
            {/if}
        </div>

		<!-- svelte-ignore a11y-autofocus -->
    	<div style="text-align: right;">
			<button on:click={() => dialog.close()}>닫기</button>
            <button
                on:click={() => ContetnsEditCheck(Num)}
                disabled={data.check != true && data.check != ''}
            >
                확인
            </button>
		</div>
</dialog>

<style lang='scss'>
    dialog {
        border-radius: 4px;
        border: 1px solid #ffffff;
        padding: 0;
        background-color: $cl1;
        color: #ffffff;

        & > div {
            padding: 10px;
        }

        &::backdrop {
            background: rgba(0, 0, 0, 0.8);
        }

        &[open] {
            animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes zoom {
            from {
                transform: scale(0.95);
            }
            to {
                transform: scale(1);
            }
        }
        &[open]::backdrop {
            animation: fade 0.2s ease-out;
        }
        @keyframes fade {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }

    .editModal {
        width: calc(100%);
        max-width: 290px;
        height: fit-content;

        .title {
            color: $cl4;
            font-size: 18px;
            font-family: aggro;
        }

        .form {
            width: calc(100% - 20px);
            height: fit-content;
            padding: 10px;

            .grid {
                width: 100%;
                height: fit-content;
                display: grid;
                grid-template-columns: calc(25%) calc(75% - 10px);
                grid-column-gap: 10px;

                label {
                    padding: 2px;
                    font-size: 16px;
                    vertical-align: middle;
                }
                input {
                    margin: 0px;
                    vertical-align: middle;
                    &[type=checkbox] {
                        width: 21px;
                        height: 21px;
                        margin: 2px 0;
                        cursor: pointer;
                    }
                }
                    
            }
            .issue {
                margin-top: 10px;
                margin-left: calc(25% + 10px);
                color: $cl4;
                font-size: 12px;
                font-family: aggro;
            }
        }
    }
</style>
